import React, { lazy } from "react";
import * as styles from "./ParagraphContactBlock.module.scss";

import useWindowLocationHref from "../../../hooks/useWindowLocationHref";

import SSRSuspense from "../../../components/SSRSuspense/SSRSuspense";
import type { IconName } from "../../../components/common";
import { Colours } from "../../../utils/colours";
import WrappedSection from "../../WrappedSection/WrappedSection";

const SocialSharing =
	process.env.GATSBY_IS_IE === "true"
		? lazy(
				() =>
					import("../../../components/common/SocialSharing/SocialSharing.ie"),
			)
		: lazy(
				() => import("../../../components/common/SocialSharing/SocialSharing"),
			);
export interface ParagraphContactBlockProps {
	heading: string;
	icon: IconName;
	linkUrl: string;
	linkText: string;
}

export const getParagraphContactBlockProps = ({
	field_contact_block_icon,
	field_contact_block_text,
	field_contact_block_url,
	field_heading,
}: Queries.ParagraphContactBlockDataFragment): ParagraphContactBlockProps => ({
	heading: field_heading,
	linkText: field_contact_block_text,
	icon: field_contact_block_icon as IconName,
	linkUrl: field_contact_block_url,
});
export const ParagraphContactBlock: React.FC<ParagraphContactBlockProps> = ({
	heading,
	linkText,
	icon,
	linkUrl,
}) => {
	const { windowLocationHref } = useWindowLocationHref();
	const hasIcon = [
		"ShareEmail",
		"ShareFacebook",
		"ShareX",
		"SocialInstagram",
		"SocialYoutube",
		"Clock",
		"Phone",
	].includes(icon);

	const Icon: React.FC = hasIcon
		? lazy(() => import(`../../../components/common/Icons/${icon}`))
		: () => null;

	return (
		<WrappedSection
			sectionName="ParagraphContactBlock"
			sectionColour={Colours.SUNSHINE_YELLOW}
		>
			<div className={styles.paragraphcontactblockinner}>
				<h3 className={styles.title}>{heading}</h3>
				<div className={styles.content}>
					<div className={styles.icon}>
						<SSRSuspense>
							<Icon />
						</SSRSuspense>
					</div>
					<div className={styles.url}>
						<a href={linkUrl}>{linkText}</a>
					</div>
				</div>
				<div className={styles.sharewrapper}>
					<SSRSuspense>
						<SocialSharing
							title="Share with someone else"
							shareBodyText="I saw this on the Dogs Trust's website and thought of you"
							sharePath={windowLocationHref}
							hasHighlightedTitle={true}
						/>
					</SSRSuspense>
				</div>
			</div>
		</WrappedSection>
	);
};

export default ParagraphContactBlock;
